/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createCardSkin} from '../api'

export const useMutationCreateCardSkin = createReactQueryMutationHook('createCardSkin', createCardSkin)
